import { ButtonProps, CustomThemeButton } from '@atlaskit/button';
import React, { FC, ReactNode } from 'react';

interface OwnProps extends Pick<ButtonProps, 'appearance' | 'href' | 'target' | 'iconAfter' | 'className' | 'onClick'> {
  color?: string;
  children?: ReactNode;
}

const LinkButton: FC<OwnProps> = ({ appearance, href, target, iconAfter, onClick, children }) => (
  <CustomThemeButton
    appearance={appearance ?? 'subtle-link'}
    href={href}
    target={target}
    rel={'noreferrer'}
    iconAfter={iconAfter}
    onClick={onClick}
  >
    {children}
  </CustomThemeButton>
);

export default LinkButton;
